const translations = {
  "en": {
    "Bookmark": "Bookmark",
    "History": "History",
    "New Chat": "New Chat",
    "Rename": "Rename",
    "Share": "Share"
  },
  "zh-tw": {
    "Bookmark": "加入書籤",
    "History": "歷史紀錄",
    "New Chat": "新對話",
    "Rename": "重新命名",
    "Share": "分享"
  }
};

export default translations;
